import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { DATA_DOG } from '../config';
import { checkIfProduction } from './admin';

export function setupDataDog() {
  const dataDogOptions = {
    ...DATA_DOG,
    sampleRate: 100,
    silentMultipleInit: true,
    sessionReplaySampleRate: 100,
    useCrossSiteSessionCookie: true,
    trackSessionAcrossSubdomains: true,
    version: process.env.REACT_APP_VERSION,
    useSecureSessionCookie: process.env.REACT_APP_STAGE !== 'local',
  };

  datadogRum.init({
    ...dataDogOptions,
    allowedTracingOrigins: [/https:\/\/.*\.joinassembly\.com/],

    trackFrustrations: true,
    trackInteractions: true,
    defaultPrivacyLevel: checkIfProduction() ? 'mask-user-input' : 'allow',
  });

  datadogLogs.init({
    ...dataDogOptions,

    forwardConsoleLogs: ['error', 'warn'],
    forwardReports: ['csp_violation', 'deprecation', 'intervention'],
  });
}
